import React, { useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { ThemeProvider, CssBaseline } from '@mui/material';
import { theme } from './theme';
import LandingPage from './components/LandingPage';
import { StatsigProvider, useClientAsyncInit } from '@statsig/react-bindings';
import { StatsigAutoCapturePlugin } from '@statsig/web-analytics';
import { initializeTracking } from './utils/tracking';
import App from './App';
// import { HelmetProvider } from 'react-helmet-async';

const AppRouter = () => {
  const { client } = useClientAsyncInit(
    "client-yOVRv4CM5VMATJ07Z8jraTwm3vlbSjp9jjfebJGkPOg",
    { plugins: [ new StatsigAutoCapturePlugin() ] },
  );

  // Initialize tracking with Statsig client when it's available
  useEffect(() => {
    if (client) {
      initializeTracking(client);
    }
  }, [client]);

  return (
    // <HelmetProvider>
      <StatsigProvider client={client}>
        <ThemeProvider theme={theme}>
          <CssBaseline />
          <Router>
            <Routes>
              <Route
                path="/"
                element={
                  new URLSearchParams(window.location.search).size === 0 ? (
                    <LandingPage />
                  ) : (
                    <App />
                  )
                }
              />
              <Route path="*" element={<LandingPage />} />
            </Routes>
          </Router>
        </ThemeProvider>
      </StatsigProvider>
    // </HelmetProvider>
  );
};

export default AppRouter; 